module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-photograph.c5037d81.png";